import { GenericResponse } from './../model/genericResponse';
import { Observable } from 'rxjs';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { HttpClient } from '@angular/common/http';
import { TipoMaterialDto, SaveTipoMaterialDto, SearchTipoMaterialRequest } from '../model/tipoMaterial';
import { CrudService } from '.';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TipoMaterialService extends CrudService<TipoMaterialDto, number, SaveTipoMaterialDto, SearchTipoMaterialRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'TipoMaterial', sharedFunctions);
  }

  getAll(): Observable<GenericResponse<TipoMaterialDto[]>> {
    return this._http.get<GenericResponse<TipoMaterialDto[]>>(this._serviceUrl + '/get-all' , this.httpOptions);
  }
}
